import Modal from 'react-bootstrap/Modal';
import Button from '../../../Components/Button/Button';
import HandPointer from "../../../Assets/images/Mano_pointer.svg";

const HandIcon = () => (
	<img
		src={HandPointer}
		alt="Hand Pointer"
		width={48}
		height={48}
		style={{
			width: "48px",
			height: "48px",
			objectFit: "contain"
		}}
	/>
);


const ModalIspRecuerda = ({ maxPeriodos = 0, ...props }) => {
	return (
		<Modal
			{...props}
			size="md"
			centered
			backdropClassName="backdrop-dark"
			className="modal--bg-gray"
			backdrop="static"
			keyboard={false}
		>
			<Modal.Body className="p-4">
				<div className="bg-white rounded p-4 d-flex flex-column align-items-center text-center">
					<div className="d-flex justify-content-end w-100 mb-2">
						<Button type="button" design="btn-outline-pewter-blue p-2 lh-1 fs-3" onClick={props.onHide}>
							<i className="ico-close"></i>
						</Button>
					</div>
					<div className="mb-3">
						<HandIcon />
					</div>
					<h5 className="fs-3 mb-3 modal-IspRecuerd-title">¿Quieres seleccionar otro periodo?</h5>
					<p className="modal-IspRecuerd-texto fs-5 mb-4">
						Recuerda que puedes seleccionar máximo {maxPeriodos || 0},<br />
						deselecciona un periodo para permitir una nueva selección.
					</p>
					<Button type="button" design="btn-primary px-5" onClick={props.onHide}>¡Entendido!</Button>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default ModalIspRecuerda;
